// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.addActionPlanForm {
  width: 95%;
  padding: 10px;
  border-collapse: collapse;
  margin: 0 auto;
}

.addActionPlanForm .addAttachmentlink {
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  -webkit-text-decoration-line: underline;
  text-decoration-line: underline;
  color: #717171;
}

.addActionPlanForm td {
  padding-top: 10px;
  padding-bottom: 10px;
}

.addActionPlanForm tr:last-child td {
  padding-bottom: 20px;
}

.addActionPlanForm .txtboxrounded {
  width: 100%;
  background: #F1F1F1;
  border-radius: 78px;
}

.addActionPlanForm .control-input {
  background: #F8F8F8;
  border-radius: 6px;
  height: 30px;
  text-align: center;
}

.addActionPlanForm .control-input-holder input {
  padding-top: 0px;
  text-align: left;
}

.addActionPlanForm .control-select-inner {
  background: #F8F8F8;
  display: flex;
  justify-content: space-between;
}

.addActionPlanForm .control-select-filter-inner {
  background: #F8F8F8;
}

.addActionPlanForm .control-select-select {
  max-width: 122px;
}

.addActionPlanForm .statusText {
  height: 25px;
  border-radius: 6px;
  text-align: center;
  display: block;
}

.addActionPlanForm td {
  width: 50%;
  padding-left: 0px !important;
}

.red .control-select-inner {
  border: 1px solid red;
}

.red .control-autocomplete-inner {
  border: 1px solid red;
}

.icon-container-actionplan {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 30px;
}

.img-container-cover {
  -o-object-fit: contain;
  object-fit: contain;
  -o-object-fit: cover;
  object-fit: cover;
  -o-object-position: center;
  object-position: center;
  width: 100%;
  max-width: 100px;
  height: 100%;
  border-radius: 10px 10px 0px 0px;
  margin-right: 9px;
}`, "",{"version":3,"sources":["webpack://./styles.scss"],"names":[],"mappings":"AAAA;EAAmB,UAAA;EAAY,aAAA;EAAc,yBAAA;EAA0B,cAAA;AAKvE;;AAJA;EAAsC,kBAAA;EAAmB,gBAAA;EAAiB,eAAA;EAAgB,iBAAA;EAAkB,uCAAA;EAAA,+BAAA;EAAgC,cAAA;AAa5I;;AAZA;EAAsB,iBAAA;EAAmB,oBAAA;AAiBzC;;AAhBA;EAAsC,oBAAA;AAoBtC;;AAnBA;EAAkC,WAAA;EAAY,mBAAA;EAAoB,mBAAA;AAyBlE;;AAxBA;EAAkC,mBAAA;EAAoB,kBAAA;EAAmB,YAAA;EAAc,kBAAA;AA+BvF;;AA9BA;EAA+C,gBAAA;EAAiB,gBAAA;AAmChE;;AAlCA;EAAyC,mBAAA;EAAqB,aAAA;EAAe,8BAAA;AAwC7E;;AAvCA;EAAgD,mBAAA;AA2ChD;;AA1CA;EAA0C,gBAAA;AA8C1C;;AA7CA;EAA+B,YAAA;EAAa,kBAAA;EAAmB,kBAAA;EAAoB,cAAA;AAoDnF;;AAnDA;EAAuB,UAAA;EAAY,4BAAA;AAwDnC;;AAvDA;EACQ,qBAAA;AA0DR;;AAvDI;EACI,qBAAA;AA0DR;;AAxDA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;AA2DJ;;AAxDA;EACQ,sBAAA;EACA,mBAAA;EACA,oBAAA;EAAA,iBAAA;EACA,0BAAA;EAAA,uBAAA;EACA,WAAA;EACA,gBAAA;EACA,YAAA;EACA,gCAAA;EACA,iBAAA;AA2DR","sourcesContent":[".addActionPlanForm {\n  width: 95%;\n  padding: 10px;\n  border-collapse: collapse;\n  margin: 0 auto;\n}\n\n.addActionPlanForm .addAttachmentlink {\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 16px;\n  text-decoration-line: underline;\n  color: #717171;\n}\n\n.addActionPlanForm td {\n  padding-top: 10px;\n  padding-bottom: 10px;\n}\n\n.addActionPlanForm tr:last-child td {\n  padding-bottom: 20px;\n}\n\n.addActionPlanForm .txtboxrounded {\n  width: 100%;\n  background: #F1F1F1;\n  border-radius: 78px;\n}\n\n.addActionPlanForm .control-input {\n  background: #F8F8F8;\n  border-radius: 6px;\n  height: 30px;\n  text-align: center;\n}\n\n.addActionPlanForm .control-input-holder input {\n  padding-top: 0px;\n  text-align: left;\n}\n\n.addActionPlanForm .control-select-inner {\n  background: #F8F8F8;\n  display: flex;\n  justify-content: space-between;\n}\n\n.addActionPlanForm .control-select-filter-inner {\n  background: #F8F8F8;\n}\n\n.addActionPlanForm .control-select-select {\n  max-width: 122px;\n}\n\n.addActionPlanForm .statusText {\n  height: 25px;\n  border-radius: 6px;\n  text-align: center;\n  display: block;\n}\n\n.addActionPlanForm td {\n  width: 50%;\n  padding-left: 0px !important;\n}\n\n.red .control-select-inner {\n  border: 1px solid red;\n}\n\n.red .control-autocomplete-inner {\n  border: 1px solid red;\n}\n\n.icon-container-actionplan {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 30px;\n}\n\n.img-container-cover {\n  -o-object-fit: contain;\n  object-fit: contain;\n  object-fit: cover;\n  object-position: center;\n  width: 100%;\n  max-width: 100px;\n  height: 100%;\n  border-radius: 10px 10px 0px 0px;\n  margin-right: 9px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
